// extracted by mini-css-extract-plugin
module.exports = {"navButton":"NavButton_navButton__2Ezjy"};